/*import { createStore } from 'vuex'

export default createStore({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})*/

import Vuex from 'vuex'

//Vue.use(Vuex);

export default new Vuex.Store({
  // The information we are sharing throughout the app
  state: {
    hive_client: {},
    user: {},
    watchlist: [],
    market_map: [],
    reference_grouped: [],
    settings: {},
    usd_dec: undefined,
    last_dates: [],
    refresh_nums: [],
    audio: {},
  },
  // Syncronous way to update the state in out vuex store
  mutations: {
    /*setUser(state, payload) {
      state.user = payload;
    }*/
  },
  actions: {},
  modules: {},
  // Grab information and display it in the app
  getters: {
    /*getUser(state) {
      return state.user;
    }*/
    // getCurrentJoke: (state) => state.currentJoke;
  }
})
